import { inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { commonActionCreators, genericEntityActionCreators } from '../actions/genericEntityActionCreators.js';
import { connectGenericProps } from './connectGenericProps.js';
import { ContainerProvider } from './ContainerContext.js';
import { PageWrapper } from '../components/Layout/PageWrapper.js';
import { MessagesModule } from '../components/Layout/Modules/MessagesModule.js';
import { renderContainerChildren } from '../utils/RenderUtil.js';
var _excluded = ["WrapperComponent"];
/** a container that handles loading collections/generating actions and passes these props down to its children */

var WrappedContainer = /*#__PURE__*/function (_React$Component) {
  function WrappedContainer(props) {
    var _this;

    _classCallCheck(this, WrappedContainer);

    _this = _callSuper(this, WrappedContainer, [props]);
    var config = props.config,
        _props$config$actionC = props.config.actionCreators,
        actionCreators = _props$config$actionC === void 0 ? {} : _props$config$actionC,
        dispatch = props.dispatch;
    _this.actions = bindActionCreators(_objectSpread2(_objectSpread2(_objectSpread2({}, commonActionCreators), genericEntityActionCreators(config, props)), actionCreators), dispatch);
    return _this;
  }

  _inherits(WrappedContainer, _React$Component);

  return _createClass(WrappedContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          WrapperComponent = _this$props.WrapperComponent,
          additionalProps = _objectWithoutProperties(_this$props, _excluded);

      var containerProps = _objectSpread2(_objectSpread2({}, additionalProps), this.actions);

      return /*#__PURE__*/React.createElement(ContainerProvider, {
        value: containerProps
      }, /*#__PURE__*/React.createElement(WrapperComponent, null, !this.props.config.excludeMessages && /*#__PURE__*/React.createElement(MessagesModule, null), renderContainerChildren(containerProps)));
    }
  }]);
}(React.Component);

_defineProperty(WrappedContainer, "propTypes", {
  children: PropTypes.node,
  collection: PropTypes.array,

  /** see "src/actions/genericEntityActionCreators" for configuration */
  config: PropTypes.object.isRequired,
  currentEntity: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object,
  WrapperComponent: PropTypes.elementType
});

_defineProperty(WrappedContainer, "defaultProps", {
  WrapperComponent: PageWrapper
});

WrappedContainer.displayName = "WrappedContainer";

var createContainer = function createContainer(config) {
  return connectGenericProps(config)(WrappedContainer);
};

export { createContainer };